import { render, staticRenderFns } from "./BuyNFT.vue?vue&type=template&id=658def13&scoped=true"
import script from "./BuyNFT.vue?vue&type=script&lang=js"
export * from "./BuyNFT.vue?vue&type=script&lang=js"
import style0 from "./BuyNFT.vue?vue&type=style&index=0&id=658def13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658def13",
  null
  
)

export default component.exports